import { Box, Link, Typography } from '@mui/material';
import type { GetArAgingReportResponse } from '@vy/api-definition';
import type { ItemOf } from '@vy/utils';
import React from 'react';
import { Price } from '../../../../../components/design/Price';

type BreakdownItem = ItemOf<GetArAgingReportResponse['summaryBreakdown']>;

type ArAgingInvoiceDetailPanelProps = {
  invoices: BreakdownItem[];
};

/**
 * Bucket indices: 0 = 1-30, 1 = 31-60, 2 = 61-90, 3 = 91+
 */
function getAgingBucketIndex(daysOutstanding: number): number {
  if (daysOutstanding <= 30) return 0;
  if (daysOutstanding <= 60) return 1;
  if (daysOutstanding <= 90) return 2;
  return 3;
}

const BUCKET_COUNT = 4;

const cellSx = { display: 'flex', justifyContent: 'center', fontSize: '13px' };

export const ArAgingInvoiceDetailPanel: React.FC<ArAgingInvoiceDetailPanelProps> = ({ invoices }) => {
  return (
    <Box sx={{ py: 1, backgroundColor: 'grey.50' }}>
      {invoices.map((item) => {
        const activeBucket = getAgingBucketIndex(item.daysOutstanding);

        return (
          <Box
            key={item.invoice.id}
            sx={{
              display: 'grid',
              gridTemplateColumns: '40px 1fr 1fr 1fr 1fr 1fr 1fr',
              alignItems: 'center',
              py: 0.75,
              borderBottom: '1px solid',
              borderColor: 'divider',
              '&:last-child': { borderBottom: 'none' },
              '&:hover': { backgroundColor: 'action.hover' },
            }}
          >
            <Box />
            <Box
              sx={{
                pl: 4,
                position: 'sticky',
                left: 40,
                backgroundColor: 'inherit',
                zIndex: 1,
              }}
            >
              <Link
                href={`/invoices/${item.invoice.id}/customer/${item.customer.id}/dynamic`}
                target="_blank"
                rel="noopener noreferrer"
                underline="hover"
                color="primary"
                sx={{ fontWeight: 500, fontSize: '13px' }}
              >
                {item.invoice.invoiceNumber}
              </Link>
            </Box>
            {Array.from({ length: BUCKET_COUNT }, (_, i) => (
              <Box key={i} sx={cellSx}>
                {i === activeBucket ? (
                  <Price>{item.remainingAmount}</Price>
                ) : (
                  <Typography variant="body2" sx={{
                    color: "text.disabled"
                  }}>-</Typography>
                )}
              </Box>
            ))}
            <Box sx={cellSx}>
              <Price>{item.remainingAmount}</Price>
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};
